import axios from 'axios'

import { handleErrorAndGenerateMessage } from '../../../functions/errorHandling'
import { getServerUrl } from '../../../functions/getServerUrl'

let defaultState = {
  fetchingChartStatistics: false,
  chartStatistics: {},
}

export default function chartStatisticsReducer(state = defaultState, action) {
  switch (action.type) {
    case "FETCHING_CHART_STATISTICS":
      return { ...state, fetchingChartStatistics: true }
    case "SET_CHART_STATISTICS":
      return {
        ...state,
        fetchingChartStatistics: false,
        chartStatistics: action.payload,
      }
    default:
      return state
  }
}

const fetchingChartStatistic = () => {
  return { type: "FETCHING_CHART_STATISTICS" }
}

const setChartStatistics = (chartStats) => {
  return { type: "SET_CHART_STATISTICS", payload: chartStats }
}

export const getChartStatistics = (alert) => {
  return (dispatch) => {
    dispatch(fetchingChartStatistic())
    axios({
      method: "GET",
      url: `${getServerUrl()}/chart-statistics/`,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    })
    .then((response) => {
      return dispatch(setChartStatistics(response.data))
    })
    .catch(error => {
      const message = handleErrorAndGenerateMessage(error, 'retrieving the patient chart statistics from the server', dispatch)
      if (alert && alert.show) {
        alert.show(message)
      }
      return dispatch(setChartStatistics({}))
    })
  }
}
